import styled from 'styled-components'

export const StyledMobileFilterFooter = styled.div`
    button {
        background-color: transparent;
        color: ${({ theme }) => theme.filterSelectBg};
        border: 1px solid ${({ theme }) => theme.filterSelectBg};
        height: 56px;
        width: 100%;
        display: flex;
        flex-direction: row-reverse;

        .text {
            font-family: ${(props) => props.theme.fontText};
            font-weight: 500;
            font-size: 16px;
        }
    }
`